// src/internal/constants/form-ids.ts
var CHANGE_PASSWORD_FORM_ID = "change-password-form";
var TWO_FACTOR_TOTP_FORM_ID = "two-factor-totp-form";

export {
  CHANGE_PASSWORD_FORM_ID,
  TWO_FACTOR_TOTP_FORM_ID
};
